import { render, staticRenderFns } from "./UdefModal.vue?vue&type=template&id=649d39fa&scoped=true&"
import script from "./UdefModal.vue?vue&type=script&lang=js&"
export * from "./UdefModal.vue?vue&type=script&lang=js&"
import style0 from "./UdefModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UdefModal.vue?vue&type=style&index=1&id=649d39fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d39fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
